import { MenuItem, MenuList, Checkbox, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    root: {},
    subMenu: {
        marginLeft: '20px',
        maxHeight: '45vh',
        overflowY: 'scroll'
    }
}));

const CheckboxAll = props => {
    const classes = useStyles();
    const { options, setOptions, title, allOptions, setAllOptions, id } = props;
    useEffect(() => {
        if (allOptions) {
            let newOptions = options.map(option => {
                return {
                    ...option,
                    checked: true
                };
            });
            setOptions(newOptions);
        }
    }, [allOptions])
    const handleChangeAll = event => {
        let newOptions = options.map(option => {
            return {
                ...option,
                checked: !options.every(option => option.checked)
            };
        });
        setOptions(newOptions);
        setAllOptions(!options.every(option => option.checked));
    };
    const handleChange = event => {
        let newOptions = options.map(option => {
            if (option.uuid === event.uuid) {
                return {
                    ...option,
                    checked: !option.checked
                };
            }
            return option;
        });
        setOptions(newOptions);
    };
    return (
        <div>
            <MenuList>
                <MenuItem key={id} onClick={(e) => handleChangeAll(e)}>
                    <Checkbox
                        checked={allOptions || options.every(option => option.checked)}
                        indeterminate={options.some(option => option.checked) && !options.every(option => option.checked)}
                    />
                    <Typography>
                        {title}
                    </Typography>
                </MenuItem>
                <div className={classes.subMenu}>
                    {options.map(option => (
                        <MenuItem key={option.uuid} disabled={options.every(option => option.checked) || option.disabled} onClick={() => handleChange(option)}>
                            <Checkbox
                                checked={option.checked}
                            />
                            <Typography>
                                {option.name}
                            </Typography>
                        </MenuItem>
                    ))}
                </div>
            </MenuList>
        </div>
    )
}

export default CheckboxAll;